import { questionTypes } from 'sharedParts';

const generateBlockPageNumber = (resultArray, currentBlock, index) => {
  const isFirstBlock = index === 0;
  if (isFirstBlock) {
    resultArray.push({
      ...currentBlock,
      page: 0,
    });
    return resultArray;
  }

  const { page: prevBlockPageNumber, type: prevBlockType } = resultArray[
    index - 1
  ];
  const isPrevBlockButton = [
    questionTypes.nextButton,
    questionTypes.submitButton,
  ].includes(prevBlockType);

  resultArray.push({
    ...currentBlock,
    page: isPrevBlockButton ? prevBlockPageNumber + 1 : prevBlockPageNumber,
  });

  return resultArray;
};

const arrangeBlocksPageNumber = blocks =>
  blocks.reduce(generateBlockPageNumber, []);

export default arrangeBlocksPageNumber;
